import React from 'react';

const Error = () => {
    return (
        <div>
            <h1 className="text-center mt-5 pt-5 ">404 Error! </h1>
            <br />
            <h4 className="text-center  pt-5">Page is not available</h4>
        </div>
    );
};

export default Error;